export default "__VITE_ASSET__nuUxzBj2__"